import { useEffect, useState, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; // IMPORTANTE
import { Card } from '@mui/material';

import { useWSContext } from '../../context/WebSocketContext';
import AreaMensagem from './AreaMensagem';
import ChatFooter from './ChatFooter';
import ChatHead from './ChatHead';

function ModuloChat({ userChat, openCloseModal = false, setOpenCloseModal }) {
  const theme = useTheme();
  const navigate = useNavigate(); // IMPORTANTE para redirecionar

  const {
    handleSendMessageWS,
    myUser,
    newMessage,
    reconnectingClients,
    chatsEncerrados,
    removeChat,
    marcarChatComoEncerrado,
    reconnectCountdowns,
  } = useWSContext();

  const [chatMessages, setChatMessages] = useState([]);
  const [encerraCampo, setEncerraCampo] = useState(false);
  const [replyTarget, setReplyTarget] = useState(null);

  const currentChatId = userChat?.state?.id;
  const isClientReconnecting = reconnectingClients.has(currentChatId);
  const reconnectCountdown = reconnectCountdowns.get(currentChatId) || 60;

  const [showEncerrarModal, setShowEncerrarModal] = useState(false);

  // Abrir modal automaticamente se veio do X com wantClose
  useEffect(() => {
    if (userChat?.state?.wantClose && !showEncerrarModal) {
      setShowEncerrarModal(true);
      if (setOpenCloseModal) setOpenCloseModal(false);
    }
  }, [userChat, showEncerrarModal, setOpenCloseModal]);

  // REDIRECIONA PRA HOME APÓS ENCERRAR
  useEffect(() => {
    if (currentChatId && chatsEncerrados.includes(currentChatId)) {
      setTimeout(() => {
        navigate('/app/home');
      }, 700);
    }
  }, [chatsEncerrados, currentChatId, navigate]);

  const encerrarChatHead = useCallback(
    (value) => {
      if (!currentChatId) return;
      const mensagem = { serviceType: 'disconnectCliente', id: currentChatId };
      handleSendMessageWS(mensagem);
      marcarChatComoEncerrado(currentChatId);
      setEncerraCampo(value);
    },
    [currentChatId, handleSendMessageWS, marcarChatComoEncerrado]
  );

  useEffect(() => {
    if (currentChatId) {
      try {
        const storedMessages = localStorage.getItem(currentChatId);
        setChatMessages(storedMessages ? JSON.parse(storedMessages) : []);
      } catch (error) {
        console.error(`Erro ao carregar histórico do chat ${currentChatId}:`, error);
        setChatMessages([]);
      }
    }
  }, [currentChatId]);

  useEffect(() => {
    if (currentChatId && chatsEncerrados.includes(currentChatId)) {
      setEncerraCampo(true);
      localStorage.removeItem(currentChatId);

      const removalTimer = setTimeout(() => {
        removeChat(currentChatId);
      }, 3000);

      return () => clearTimeout(removalTimer);
    }
    return () => {};
  }, [chatsEncerrados, currentChatId, removeChat]);

  useEffect(() => {
    if (
      currentChatId &&
      newMessage?.id === currentChatId &&
      newMessage?.mensagemTipo !== 'SYSTEM_MESSAGE'
    ) {
      setChatMessages((prevMessages) => [...prevMessages, newMessage]);
      if (encerraCampo) {
        setEncerraCampo(false);
      }
    }
  }, [newMessage, currentChatId, encerraCampo]);

  const recebeMensagemSuporte = useCallback(
    (message) => {
      if (!message || !currentChatId) return;

      const digitando = {
        serviceType: 'typingStatus',
        id: currentChatId,
        name: myUser?.name,
        typing: 'False',
      };

      setChatMessages((prev) => [...prev, message]);
      handleSendMessageWS(message);

      try {
        const stored = JSON.parse(localStorage.getItem(currentChatId)) || [];
        stored.push(message);
        localStorage.setItem(currentChatId, JSON.stringify(stored));
      } catch (error) {
        console.error('Falha ao salvar mensagem do suporte no localStorage', error);
      }

      setTimeout(() => {
        handleSendMessageWS(digitando);
      }, 300);
    },
    [currentChatId, myUser, handleSendMessageWS]
  );

  const bloquearCampo = useCallback((value) => {
    setEncerraCampo(value);
  }, []);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        whiteSpace: 'pre-line',
        height: '80vh',
        background: theme.palette.gradients.dark,
        boxShadow: theme.shadows[10],
      }}
    >
      <ChatHead
        recebeEncerraChat={encerrarChatHead}
        userChat={userChat}
        isClientReconnecting={isClientReconnecting}
        reconnectCountdown={reconnectCountdown}
        nomeAtendente={myUser?.name}
        chatId={currentChatId}
        openEncerrarModal={showEncerrarModal}
        setOpenEncerrarModal={setShowEncerrarModal}
      />
      <AreaMensagem
        escreveMensagemSuporte={chatMessages}
        userChat={userChat}
        recebeEncerraChat={bloquearCampo}
        onReplyMessage={setReplyTarget}
      />
      <ChatFooter
        userChat={userChat}
        chatId={currentChatId}
        mensagemSuporte={recebeMensagemSuporte}
        encerrarChat={encerraCampo}
        replyTarget={replyTarget}
        onCancelReply={() => setReplyTarget(null)}
      />
    </Card>
  );
}

export default ModuloChat;
